import { render, staticRenderFns } from "./JsonTreeView.vue?vue&type=template&id=89d1c7a4&scoped=true"
import script from "./JsonTreeView.vue?vue&type=script&lang=js"
export * from "./JsonTreeView.vue?vue&type=script&lang=js"
import style0 from "./JsonTreeView.vue?vue&type=style&index=0&id=89d1c7a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d1c7a4",
  null
  
)

export default component.exports